export const query_normativa = `
query getNormativa {
  normativa(order_by: {OrderN: asc}) {
    Id
    ParentId
    Title
    Subtitle
    Description
    TitoloN
    CapoN
    SezioneN
    ArticoloN
    OrderN
  }
}`;